import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "49.949",
  width: "50",
  viewBox: "0 0 50 49.949",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M48.173 15.3h1.777v-3.553H32.996V-.03h-20.76C8.02.17 0 2.77 0 11.97v26.09c0 .56.05 1.117.1 1.676.915 7.92 8.174 10.203 12.133 10.254h20.812V38.213H50V34.66H32.993V15.37H48.17zm-18.73 19.29v11.776H11.98c-1.522-.102-7.918-.965-8.375-7.564V11.188c.457-7.26 7.817-7.665 8.68-7.665h17.157V34.59z"
  })]
});